module.exports = __webpack_public_path__ + "static/img/automotive-service-advisor.f8de604.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-3/automotive-service-advisor.png
// module id = oBrC
// module chunks = 0